import { GYM, TCP, SNJ, PJP, CLEARANCE } from './brands.constants';
import { CATALOG_ID_CONFIG } from './brandSpecific.server.constants';

const SHOW_SMS_NOTIFICATION = {
  [TCP]: {
    USA: true,
    Canada: true,
  },
  [GYM]: {
    USA: true,
    Canada: false,
  },
  [SNJ]: {
    // BRAND-SPECIFIC-TODO
    USA: true,
    Canada: true,
  },
  [PJP]: {
    // PJP-ToDo
    USA: true,
    Canada: false,
  },
  [CLEARANCE]: {
    USA: true,
    Canada: true,
  },
};

const SHOW_SMS_SIGN_UP = {
  [TCP]: {
    USA: true,
    Canada: true,
  },
  [GYM]: {
    USA: true,
    Canada: false,
  },
  [SNJ]: {
    // BRAND-SPECIFIC-TODO
    USA: true,
    Canada: true,
  },
  [PJP]: {
    // PJP-ToDo
    USA: true,
    Canada: false,
  },
  [CLEARANCE]: {
    USA: true,
    Canada: true,
  },
};

export { CATALOG_ID_CONFIG, SHOW_SMS_NOTIFICATION, SHOW_SMS_SIGN_UP };
